(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-track-sizes"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const tagTabs = document.querySelectorAll('.tag-tab');
  const gridContainer = document.getElementById('featured-tracks-grid');
  const tabsSlider = document.getElementById('tabsSlider');
  const arrowLeft = document.getElementById('arrowLeft');
  const arrowRight = document.getElementById('arrowRight');
  const scrollAmount = 200;

  const allProductLinks = Array.from(gridContainer.querySelectorAll('.card-link'));
  const allCardData = allProductLinks.map(link => {
    const tags = link.querySelector('.featured-track-card')
      .getAttribute('data-tags')
      .split(',')
      .map(t => t.trim().toLowerCase());
    return { tags, html: link.outerHTML };
  });

  function renderCardsForTag(tag) {
    const normalizedTag = tag.trim().toLowerCase();
    const filtered = allCardData.filter(card =>
      card.tags.some(t => t.includes(normalizedTag))
    );

    if (filtered.length > 0) {
      const html = filtered.slice(0, 5).map(card => card.html).join('');
      gridContainer.innerHTML = html;
    } else {
      gridContainer.innerHTML = '<p>No products found for this tag.</p>';
    }
  }

  tagTabs.forEach(tab => {
    tab.addEventListener('click', e => {
      e.preventDefault();
      tagTabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      renderCardsForTag(tab.getAttribute('data-tag'));
    });
  });

  const firstTab = document.querySelector('.tag-tab.active');
  if (firstTab) renderCardsForTag(firstTab.getAttribute('data-tag'));

  arrowLeft.addEventListener('click', () => tabsSlider.scrollLeft -= scrollAmount);
  arrowRight.addEventListener('click', () => tabsSlider.scrollLeft += scrollAmount);

  function updateArrowVisibility() {
    const isOverflowing = tabsSlider.scrollWidth > tabsSlider.clientWidth;
    arrowLeft.style.display = isOverflowing ? 'block' : 'none';
    arrowRight.style.display = isOverflowing ? 'block' : 'none';
  }

  updateArrowVisibility();
  window.addEventListener('resize', updateArrowVisibility);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
var menuItems = [
  { menuId: 'HeaderMenu-rubber-tracks', textId: 'menu_text_tcjPPk' },
  { menuId: 'HeaderMenu-tools', textId: 'menu_text_MRtiH7' },
  { menuId: 'HeaderMenu-undercarriage', textId: 'menu_text_FQw3p7' }
];

// This is the "Contact Us" menu that should NOT show anything
var excludedMenuId = 'HeaderMenu-contact-us';

// Hide all visible submenu texts
function hideAllMenuTexts() {
  menuItems.forEach(function(item) {
    var textEl = document.getElementById(item.textId);
    if (textEl) textEl.style.display = 'none';
  });
}

// Apply hover and click only to allowed menus
menuItems.forEach(function(item) {
  var menuEl = document.getElementById(item.menuId);
  var textEl = document.getElementById(item.textId);

  if (!menuEl || !textEl) return;

  function showMenuText() {
    hideAllMenuTexts();
    textEl.style.display = 'block';
  }

  menuEl.addEventListener('click', function(e) {
    e.stopPropagation();
    if (textEl.style.display === 'block') {
      textEl.style.display = 'none';
    } else {
      hideAllMenuTexts();
      textEl.style.display = 'block';
    }
  });

  menuEl.addEventListener('mouseenter', showMenuText);
  textEl.addEventListener('mouseleave', hideAllMenuTexts);
});

// Prevent "Contact Us" from triggering mega menu
var contactUsMenu = document.getElementById(excludedMenuId);
if (contactUsMenu) {
  contactUsMenu.addEventListener('mouseenter', hideAllMenuTexts);
  contactUsMenu.addEventListener('click', hideAllMenuTexts);
}

// Also hide when clicking anywhere else
document.addEventListener('click', hideAllMenuTexts);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["most-purchase-tracks"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Handle tab switching for each section
    const sections = document.querySelectorAll('.rubber-tracks-section');

    sections.forEach((section) => {
      const tabs = section.querySelectorAll('.collection-tab');
      const collections = section.querySelectorAll('.collection-products');

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          tabs.forEach((t) => t.classList.remove('active'));
          collections.forEach((c) => c.classList.remove('active'));

          tab.classList.add('active');
          collections[index].classList.add('active');
        });
      });

      if (tabs.length > 0) tabs[0].classList.add('active');
      if (collections.length > 0) collections[0].classList.add('active');
    });

    // Scroll buttons and slider
    const tabsSliderTracks = document.getElementById('tabsSlider_tracks');
    const arrowLeftTracks = document.getElementById('arrowLeft-tracks');
    const arrowRightTracks = document.getElementById('arrowRight-tracks');
    const scrollAmount = 200;

    // Scroll buttons functionality
    arrowLeftTracks?.addEventListener('click', function (e) {
      e.preventDefault();
      tabsSliderTracks.scrollLeft -= scrollAmount;
    });

    arrowRightTracks?.addEventListener('click', function (e) {
      e.preventDefault();
      tabsSliderTracks.scrollLeft += scrollAmount;
    });

    // Show/hide arrows based on scrollability
    function updateArrowVisibility() {
      if (!tabsSliderTracks || !arrowLeftTracks || !arrowRightTracks) return;

      const isScrollable = tabsSliderTracks.scrollWidth > tabsSliderTracks.clientWidth;

      arrowLeftTracks.style.display = isScrollable ? 'block' : 'none';
      arrowRightTracks.style.display = isScrollable ? 'block' : 'none';
    }

    // Initial check
    updateArrowVisibility();

    // Recheck on resize
    window.addEventListener('resize', updateArrowVisibility);
  });

  } catch(e) { console.error(e); }
})();
})();
